import { ButtonMantine, CopyButton, Group, Spoiler, Stack, Text, ThemeIcon, Title } from 'ui';
import { IconLocation } from 'ui/Icons';

import { MerchantType } from '../MerchantDetailModalsProvider';

const DiningDetailDescription = ({ text, address }: { text?: string; address?: string }) => {
  return (
    <Stack gap="sm">
      <Title order={4}>Restaurant Description</Title>
      <Spoiler
        showLabel="Read More"
        hideLabel="Read Less"
        maxHeight={90}
        styles={{ control: { fontWeight: 600, fontSize: 14 } }}
      >
        <Text type="sub">{text}</Text>
      </Spoiler>
      <Group justify="space-between">
        <Group>
          <ThemeIcon variant="transparent" c="cobalt">
            <IconLocation />
          </ThemeIcon>
          <Text type="sub">{address}</Text>
        </Group>
        <CopyButton value={address ?? ''}>
          {({ copied, copy }) => (
            <ButtonMantine variant="subtle" size="compact-sm" onClick={copy}>
              {copied ? 'Copied!' : 'Copy Address'}
            </ButtonMantine>
          )}
        </CopyButton>
      </Group>
    </Stack>
  );
};
const MerchantDetailDescription = ({ type }: { type?: MerchantType }) => {
  if (type === 'dining') return null;
  return (
    <Text type="sub">
      {type === 'online'
        ? 'Shop eligible partner sites with the Givebacks browser extension and your purchases earn cash back instantly!'
        : 'Claiming the offer links your card to your purchases so you earn cash back.'}
    </Text>
  );
};
export { DiningDetailDescription, MerchantDetailDescription };
